import './util/accordion';
import 'core-js/stable';
import 'slick-carousel';
import 'regenerator-runtime/runtime';
import { ContactMenu } from './components/contact_popup/contact_popup';
import initModules from './util/initModules';
import collapse from './components/Collapse/Collapse';
import { Donation } from './components/donation/donation';
import { ExtFormCartList } from './components/Form/ExtFormCartList';
import { FAQ } from './components/Faq/Faq';
import { FixedTabs } from './components/fixedTabs/fixedTabs';
import { FrontSearch } from './components/FrontSearch/FrontSearch';
import { FrontSearchBijles } from './components/FrontSearch/FrontSearchBijles';
import { Banner } from './components/Banner/Banner';
import { FormInfoPakket } from './components/Form/FormInfopakket';
import { FormGetAddress } from './components/Form/FormGetAddress';
import { FormVacancy } from './components/Form/FormVacancy';
import { FormStep } from './components/Form/FormStep';
import { FormValidateCoupon } from './components/Form/FormValidateCoupon';
import { GFFieldAfspraakplanner } from './components/Form/GFFieldAfspraakplanner';
import { SearchExtFormAutofill } from './components/Form/SearchExtFormAutofill';
import { HeaderBar } from './components/HeaderBar/HeaderBar';
import { LocationPage } from './components/LocationPage/LocationPage';
import { LocationPrijsmodule } from './components/ACF/LocationPrijsmodule';
import { PageTabs } from './components/pageTabs/pageTabs';
import { RichDropdown } from './components/FrontSearch/RichDropdown';
import { SearchExt } from './components/SearchExt/Search';
import { SearchBooster } from './components/SearchBooster/SearchBooster';
import { SearchSchool } from './components/SearchSchool/SearchSchool';
import { SearchBijles } from './components/SearchBijles/SearchBijles';
import { SideMenu } from './components/sideMenu/SideMenu';
import { Tooltip } from './components/tooltip/Tooltip';
import { UseLocation } from './components/FrontSearch/UseLocation';
import { Youtube } from './components/youtube/Youtube';
import { ThankYouPage } from './components/ThankYouPage/ThankYouPage';
import { BoxesGrid } from './components/ACF/BoxesGrid';
import { FeaturedHomeBlocks } from './components/ACF/FeaturedHomeBlocks';
import { ScrollTopComponent } from './components/ScrollTop/ScrollTopComponent';
import { registerReactComponents } from './util/registerReactComponents';
import { Checkout } from './components/Checkout/Checkout';
import { CartIconComponent } from './components/ShoppingCartIcon/CartIconComponent';
import './util/mailplusFormValidation';
import { FormIntake } from './components/FormIntake/FormIntake';
import { FormIntakeBijlesVmbo } from './components/FormIntake/FormIntakeBijlesVmbo';
import { FormIntakeBijlesHavo } from './components/FormIntake/FormIntakeBijlesHavo';
import { FormIntakeBijlesVwo } from './components/FormIntake/FormIntakeBijlesVwo';
import DemoAanvraag from './components/DemoAanvraag/DemoAanvraag';
import './components/productSlider/productSlider';
import './components/examSlider/examSlider';
import { Shop } from './components/Shop/Shop';
import { WC_Checkout } from './components/WooCommerce/WC_Checkout';
import { WC_Cart } from './components/WooCommerce/WC_Cart';
import { WC_Product_Exam } from './components/WooCommerce/WC_Product_Exam';
import { WC_Checkout_Autofill } from './components/WooCommerce/WC_Checkout_Autofill';
import { Show_PDF_Button, Show_Webshop_Box, Remove_Div, RemoveDonation, DonationURL } from './components/WooCommerce/Show_Hide_Elements';
import { Toggle_Show_More } from './components/WooCommerce/Show-more';
import { WC_Shop_Filter_Bottom } from './components/WooCommerce/WC_Shop_Filter_Placement';
import { WC_Image_Sticky } from './components/WooCommerce/WC_Book_Image';
import './components/Shop/pdf-modal';
import { CatArchive } from './components/Categories/archive';
import './components/WooCommerce/WC_Add_to_cart_message';
import './components/WooCommerce/WC_Carousel';
import { ExamencheckJS } from './components/examencheck/examencheck';
import { ExamencheckResultaat } from './components/examencheck/examencheck-resultaat';
import './components/LobPage/Lob_Page.js';
import './components/BasisschoolPagina/BasisschoolPagina.js';
import './components/GTMDataLayer/GTMDataLayer';
import './components/GoogleApi/GoogleApi';
import './components/ContactForm/contact_form.js';
import { Popup_Notice } from './components/PopupNotice/popup_notice.js';
import './components/ACF/_slider-informatieblokken';
import './components/ACF/_grid-reviews';
import { Hwb_pakketten } from './components/ACF/_hwb-pakketten';
import { Donation23 } from './components/Donation23/donation23';
import { Keuzehulp } from './components/Keuzehulp/Keuzehulp';

/**
 * TWIG Variables
 * Variables set in template by twig, this should
 * the only place to declare these variables.
 */
declare const ajax_link: string;
declare const ajax_nonce: string;
declare const themeFolder: string;
// export template vars to rest of js.
export const ajaxLink = ajax_link;
export const ajaxNonce = ajax_nonce;
export const themeFolderPath = themeFolder;

/**
 *   Components
 */
collapse.init();

/**
 * These components are loaded on every page
 * If you want large components to load on a single page
 * you should use the initModule
 */
new Banner();
new CatArchive();
new ContactMenu();
new Donation();
new Donation23();
new DonationURL();
new ExtFormCartList();
new FixedTabs();
new FormGetAddress();
new FormInfoPakket();
new FormStep();
new FormVacancy();
new FormValidateCoupon();
new GFFieldAfspraakplanner();
new HeaderBar();
new Hwb_pakketten();
new PageTabs();
new Popup_Notice();
new Remove_Div();
//new RemoveDonation();
new RichDropdown();
new Shop();
new Show_PDF_Button();
new Show_Webshop_Box();
new SideMenu();
new ThankYouPage();
new Toggle_Show_More();
new Tooltip();
new UseLocation();
new WC_Cart();
new WC_Checkout();
new WC_Checkout_Autofill();
new WC_Image_Sticky();
new WC_Product_Exam();
new WC_Shop_Filter_Bottom();
new Youtube();

registerReactComponents([
  { component: ScrollTopComponent, selector: 'app-scroll-top-component' },
  { component: Checkout, selector: 'app-checkout' },
  { component: FormIntake, selector: 'app-form-intake' },
  { component: FormIntakeBijlesVmbo, selector: 'app-form-intake-bijles-vmbo' },
  { component: FormIntakeBijlesHavo, selector: 'app-form-intake-bijles-havo' },
  { component: FormIntakeBijlesVwo, selector: 'app-form-intake-bijles-vwo' },
  { component: CartIconComponent, selector: 'app-cart-icon-component' },
  { component: DemoAanvraag, selector: 'app-demo-aanvraag' },
]);


/**
 * @deprecated use registerReactComponents instead.
 * @see registerReactComponents
 *
 *  The modules below will only be initialized when the script finds
 *  the [data-module="<module-name>"] in the dom
 *
 *  @example
 *  <div data-module="examenCheckNiveau"></div>
 */
initModules({
  acfBoxesGrid: () => new BoxesGrid(),
  acfFeaturedHomeBlocks: () => new FeaturedHomeBlocks(),
  acfLocationPrijsmodule: () => new LocationPrijsmodule(),
  examenCheckPK: () => new ExamencheckJS(),
  examenResultPK: () => new ExamencheckResultaat(),
  faq: () => new FAQ(),
  frontSearch: () => new FrontSearch(),
  frontSearchBijles: () => new FrontSearchBijles(),
  keuzehulp: () => new Keuzehulp(),
  location: () => new LocationPage(),
  search: () => new SearchExt(), // Ext en cot
  searchBijles: () => new SearchBijles(), // Hwb, Bl en Elm
  searchSchool: () => new SearchSchool(),
  searchbooster: () => new SearchBooster(), // Ext en cot
  SearchExt: () => new SearchExtFormAutofill(),
});

